import { render } from "./AnnualConference.vue?vue&type=template&id=10ed0884"
import script from "./AnnualConference.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualConference.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AnnualConference.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10ed0884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10ed0884', __exports__)) {
    console.log('reload')
    api.reload('10ed0884', __exports__)
  }
  
  module.hot.accept("./AnnualConference.vue?vue&type=template&id=10ed0884", () => {
    console.log('re-render')
    api.rerender('10ed0884', render)
  })

}


export default __exports__